import { render, staticRenderFns } from "./DepartmentSelectBox.vue?vue&type=template&id=70c4299f&"
import script from "./DepartmentSelectBox.vue?vue&type=script&lang=ts&"
export * from "./DepartmentSelectBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports